// src/enduser/eventrings.jsx
// リング一覧（公開）。ログイン不要の公開APIを呼ぶ。
import React from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import PubHeader from "./PubHeader";
import { formatEyebrow } from "./pubutil";
import "./eventcatalog.css";

const API_URL = import.meta.env.VITE_API_URL;

export default function EnduserEventRings() {
  const { eventId } = useParams();

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["event-rings", "public", eventId],
    queryFn: async () => {
      const res = await axios.get(`${API_URL}/api/public/events/${eventId}/rings/`);
      if (!res.data?.success) throw new Error("リングの取得に失敗しました");
      return res.data.data;
    },
    // 404（非公開・存在しない）はリトライしない
    retry: (count, err) => err?.response?.status !== 404 && count < 1,
    staleTime: 0,
    refetchOnMount: "always",
  });

  const notFound = isError && error?.response?.status === 404;
  const rings = data?.rings || [];

  return (
    <div className="pubCat">
      <PubHeader to={`/events/${eventId}`} backLabel="戻る" title="リング一覧" />

      {isLoading ? (
        <div className="pubCatMsg">読み込み中...</div>
      ) : isError ? (
        <div className="pubCatMsg">
          {notFound
            ? "イベントが見つかりません"
            : `エラー: ${error?.message || "リングの取得に失敗しました"}`}
          <br />
          <Link to="/top">イベント一覧へ戻る</Link>
        </div>
      ) : (
        <>
          <div className="pubCatHero">
            <div className="pubCatInner">
              <div className="pubCatEyebrow">{formatEyebrow(data.event.date)}</div>
              <h1 className="pubCatTitle">{data.event.title}</h1>
              <div className="pubCatRule" />
            </div>
          </div>

          <div className="pubCatInner pubCatBody">
            {rings.length === 0 ? (
              <div className="pubCatMsg">リングは、まだ公開されていません</div>
            ) : (
              <div className="pubCatRings">
                {rings.map((ring) => (
                  <Link
                    key={ring.ring_no}
                    to={`/events/${eventId}/groups?ring=${ring.ring_no}`}
                    className="pubCatRing"
                  >
                    <span className="pubCatRingBadge">
                      <span className="pubCatRingLabel">RING</span>
                      <span className="pubCatRingNo">{ring.ring_no}</span>
                    </span>
                    <span className="pubCatRingBody">
                      <span className="pubCatRingJudge">{ring.judge_names.join(" ／ ")}</span>
                      {ring.groups.length > 0 && (
                        <span className="pubCatRingGroups">
                          {ring.groups.map((g) => `${g.group_no}G ${g.name}`).join("　・　")}
                        </span>
                      )}
                    </span>
                    <span className="pubCatCnt">
                      <span className="pubCatCntN">{ring.entry_count}</span>
                      <span className="pubCatCntL">頭</span>
                    </span>
                    <svg className="pubCatChev" aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#B88A50" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M9 6l6 6-6 6" />
                    </svg>
                  </Link>
                ))}
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}
